import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Hero } from "../components/Hero";
import { ProductsSection } from "../components/ProductsSection";
import { ProducersSection } from "../components/ProducersSection";
import { LogisticsSection } from "../components/LogisticsSection";
import { CertificationsSection } from "../components/CertificationsSection";
import { AboutSection } from "../components/AboutSection";
import { ContactSection } from "../components/ContactSection";

export default function HomePage() {
  const location = useLocation();
  const [preselect, setPreselect] = useState("");

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 50);
      }
    }
  }, [location.hash]);

  const goContact = (productCode) => {
    if (productCode) setPreselect(productCode);
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const goProducts = () => {
    const el = document.getElementById("products");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div data-testid="home-page" className="relative">
      <Header />
      <main>
        <Hero onCtaPrimary={() => goContact()} onCtaSecondary={goProducts} />
        <ProductsSection onSelect={(code) => goContact(code)} />
        <ProducersSection />
        <LogisticsSection />
        <CertificationsSection />
        <AboutSection />
        <ContactSection preselectProduct={preselect} />
      </main>
      <Footer />
    </div>
  );
}
